module.exports = __webpack_public_path__ + "static/media/23.381202de.JPG";